
import { Globe, Shield, Zap, Database } from "lucide-react";

const QuickOverviewSection = () => {
  const benefits = [
    {
      icon: <Globe className="h-6 w-6 text-gray-700 dark:text-nation-teal" />,
      text: "Continuous sentiment tracking across 100+ countries"
    },
    {
      icon: <Shield className="h-6 w-6 text-gray-700 dark:text-nation-teal" />,
      text: "Verified voter and citizen panels for data integrity"
    },
    {
      icon: <Zap className="h-6 w-6 text-gray-700 dark:text-nation-teal" />,
      text: "Instant alerts on spikes in public concern"
    },
    {
      icon: <Database className="h-6 w-6 text-gray-700 dark:text-nation-teal" />,
      text: "Easy API & export for custom reporting"
    }
  ];

  return (
    <section className="py-16 bg-gray-50 dark:bg-gray-900 quick-overview-section">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
              Why Global Organizations Choose NationCard™
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
              Transform uncertainty into actionable insights with the world's most comprehensive civic intelligence platform
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 dark:border-gray-700"
              >
                <div className="flex items-start gap-4">
                  <div className="bg-gray-100 dark:bg-nation-teal/20 rounded-lg p-3 flex-shrink-0">
                    {benefit.icon}
                  </div>
                  <p className="text-gray-700 dark:text-gray-300 font-medium leading-relaxed">
                    {benefit.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Stats Bar */}
          <div className="mt-16 bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-xl border border-gray-100 dark:border-gray-700">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              <div>
                <div className="text-3xl md:text-4xl font-bold text-nation-blue mb-2">2.4M+</div>
                <div className="text-gray-600 dark:text-gray-400">Verified Panelists</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-nation-teal mb-2">100+</div>
                <div className="text-gray-600 dark:text-gray-400">Countries Covered</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-nation-purple mb-2">24/7</div>
                <div className="text-gray-600 dark:text-gray-400">Real-time Monitoring</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-green-600 mb-2">99.7%</div>
                <div className="text-gray-600 dark:text-gray-400">Data Accuracy</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickOverviewSection;
